import { HrEmployeeDocument } from "@/types/hr/Hr";

const extensions = /\.(pdf|docx?|jpe?g|png|gif|bmp|webp)$/i;
const types = new Set([
  "application/pdf", "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp",
]);

export function canPreviewHrDocument(doc: HrEmployeeDocument): boolean {
  if (doc.externalFile) return false;
  return doc.source === "ESIGN_DOCUMENT" || extensions.test(doc.fileName || "") ||
    types.has((doc.contentType || "").split(";")[0].trim().toLowerCase());
}

export function hrPreviewKind(mime: string): "pdf" | "image" | null {
  const type = mime.split(";")[0].trim().toLowerCase();
  if (type === "application/pdf") return "pdf";
  return ["image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"].includes(type) ? "image" : null;
}
